export default __webpack_public_path__ + "static/media/cover_bubblehorror2.6d09375c.mp4";